import { motion } from "framer-motion";
import ChapterHeader from "./ChapterHeader";
import { CONTENT } from "../data/content";

export default function Skills() {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="relative border-t border-border py-24 md:py-40 bg-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <ChapterHeader n="02" kicker="Stack" title={<>The<br /><span className="text-accent">Toolkit</span>.</>}>
          <div className="space-y-12 md:space-y-16">
            {CONTENT.skills.map((group, gi) => (
              <motion.div
                key={group.group}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.7, delay: gi * 0.05, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start border-t border-border pt-8"
                data-testid={`skill-group-${gi}`}
              >
                <div className="md:col-span-3">
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
                    0{gi + 1} / {String(CONTENT.skills.length).padStart(2, "0")}
                  </div>
                  <h3 className="mt-2 font-heading text-2xl md:text-3xl font-black tracking-tight uppercase">
                    {group.group}
                  </h3>
                </div>
                <div className="md:col-span-9 flex flex-wrap gap-2 md:gap-3">
                  {group.items.map((item, i) => (
                    <motion.span
                      key={item}
                      initial={{ opacity: 0, y: 8 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.35, delay: i * 0.02 }}
                      className="font-mono text-xs md:text-sm px-3 md:px-4 py-2 border border-border rounded-full text-foreground/85 hover:border-accent hover:text-accent transition-colors cursor-default"
                      data-testid={`skill-pill-${gi}-${i}`}
                    >
                      {item}
                    </motion.span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </ChapterHeader>
      </div>
    </section>
  );
}
